<template>

    <div class="login-section">

        <div class="login-wrapper">

            <div class="bg" style="background-image: url('img/login/background-image.png')"></div>

            <div class="website-logo text-center">
                <img class="logo-big" src="img/login/logo-2.png" alt="">
                <img class="logo-small" src="img/login/logo.png" alt="">
            </div>

            <div class="login-content-wrapper">

                <div class="login-content">


                        <h4 class="w-medium">{{ $t('INVITE.TITLE') }}</h4>
                        <p class="w-medium">
                            {{ $t('INVITE.INFORMATION') }}
                        </p>

                        <div class="form-group row">
                            <label class="col-form-label">{{ $t('INVITE.INPUT_NAME') }}</label>
                            <input class="form-control" autocomplete="off" v-model="fullName" type="text" name="fullName" />
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label">{{ $t('INVITE.INPUT_PASSWORD') }}</label>
                            <input class="form-control" autocomplete="off" v-model="password" :type="passwordFieldType" name="password1" />
                            <span @click="switchVisibility" class="clickable fa fa-fw fa-eye field-icon"></span>
                        </div>
                        <div>
                            <button v-on:click="sendSignup" class="btn btn-fill btn-primary">
                                {{ $t('INVITE.NEXT')}}
                            </button>
                        </div>
                        <div class="mt-4">
                             <router-link :to="{ name: 'Login' }">
                                {{ $t('INVITE.BACK')}}
                            </router-link>
                            
                        </div>

                    <LocaleLogin></LocaleLogin>

                </div>

            </div>
        </div>

    </div>

</template>
<script>
    import LocaleLogin from '@/components/Layout/LocaleLogin'

    export default {
        components: {
            LocaleLogin
        },
        data() {
            return {
                errorMessage: ''
                , image: 'img/login-image.png'
                , uniqueIdentifier: ''
                , invitationCode: ''
                , fullName: ''
                , password: ''
                , passwordFieldType: 'password'
            }
        },
        methods: {
            sendSignup: function () {
                this.loading = true;
                let self = this;
                this.$http.post(process.env.VUE_APP_BACKEND + `/invite/activate`, {
                    invitationCode: this.invitationCode,
                    password: this.password,
                    name: this.fullName
                }).then(function () {
                    self.$router.push('dashboard');
                }).catch(error => {
                    self.$noty.error(self.$t(error.response.data));
                });
            },
            switchVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            }
        },
        created() {
            if (localStorage.getItem("uui") !== null) {
                this.uniqueIdentifier = localStorage.getItem("uui");
            }
            if (this.$route.query.code !== undefined) {
                this.invitationCode = this.$route.query.code;
            }
        }
    }
</script>
<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>